/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AutomationFeePercentageCondition } from './AutomationFeePercentageCondition';
import {
    instanceOfAutomationFeePercentageCondition,
    AutomationFeePercentageConditionFromJSON,
    AutomationFeePercentageConditionFromJSONTyped,
    AutomationFeePercentageConditionToJSON,
} from './AutomationFeePercentageCondition';
import type { AutomationSourceCondition } from './AutomationSourceCondition';
import {
    instanceOfAutomationSourceCondition,
    AutomationSourceConditionFromJSON,
    AutomationSourceConditionFromJSONTyped,
    AutomationSourceConditionToJSON,
} from './AutomationSourceCondition';
import type { AutomationStateCondition } from './AutomationStateCondition';
import {
    instanceOfAutomationStateCondition,
    AutomationStateConditionFromJSON,
    AutomationStateConditionFromJSONTyped,
    AutomationStateConditionToJSON,
} from './AutomationStateCondition';

/**
 * @type AutomationCondition
 * A single rule condition. Each variant is keyed by `field` and constrains its own operators and value type, so invalid field/operator/value combinations are rejected at the type level, not just server-side.
 * @export
 */
export type AutomationCondition = AutomationFeePercentageCondition | AutomationSourceCondition | AutomationStateCondition;

export function AutomationConditionFromJSON(json: any): AutomationCondition {
    return AutomationConditionFromJSONTyped(json, false);
}

export function AutomationConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomationCondition {
    if (json == null) {
        return json;
    }
    if (instanceOfAutomationFeePercentageCondition(json)) {
        return AutomationFeePercentageConditionFromJSONTyped(json, true);
    }
    if (instanceOfAutomationSourceCondition(json)) {
        return AutomationSourceConditionFromJSONTyped(json, true);
    }
    if (instanceOfAutomationStateCondition(json)) {
        return AutomationStateConditionFromJSONTyped(json, true);
    }

    return {} as any;
}

export function AutomationConditionToJSON(json: any): any {
    return AutomationConditionToJSONTyped(json, false);
}

export function AutomationConditionToJSONTyped(value?: AutomationCondition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfAutomationFeePercentageCondition(value)) {
        return AutomationFeePercentageConditionToJSON(value as AutomationFeePercentageCondition);
    }
    if (instanceOfAutomationSourceCondition(value)) {
        return AutomationSourceConditionToJSON(value as AutomationSourceCondition);
    }
    if (instanceOfAutomationStateCondition(value)) {
        return AutomationStateConditionToJSON(value as AutomationStateCondition);
    }

    return {};
}

